module.exports = __webpack_public_path__ + "static/media/delete_outline_red.23750154.svg";